module.exports = __webpack_public_path__ + "static/media/2.3138f704.mp4";